export default __webpack_public_path__ + "static/media/sharelinkb.eadc3100.svg";